const PreLoader = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center w-100"
      style={{ minHeight: '200px' }} // adjust if needed
    >
      <div className="spinner-border text-info" role="status"></div>
      <p className="mt-2 text-muted mb-0">Loading, please wait...</p>
    </div>
  );
};

export default PreLoader;